<template>
  <b-card class="shadow" no-body>
    <b-card-body class="p-4">
      <div class="d-flex justify-content-between">
        <div class="d-flex inline-flex">
          <span
            :class="`mr-4 block-icon d-flex align-items-center justify-content-center ${background}`"
          >
            <i :class="icone"></i>
          </span>
          <div class="d-flex flex-column">
            <span> {{ titulo }} </span>
            <span class="qtd_card">
              {{ counts | maskNumber }}
            </span>
          </div>
        </div>
        <div>
          <b-button
            type="button"
            class="btn btn-xs btn-card"
            :to="link"
            :variant="btnVariante"
          >
            <i class="fas fa-external-link-alt"></i>
          </b-button>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  props: ["counts", "titulo", "link", "icone", "background", "btnVariante"],
};
</script>

<style scoped>
.btn-card {
  position: absolute;
  right: -6px;
  top: 0px;
  border-radius: 0;
  border: 0;
}
.block-icon {
  font-size: 48px;
  background-image: linear-gradient(
    30deg,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.3)
  ) !important;
  padding: 15px;
  margin: -25px;
  min-width: 90px;
  text-align: center;
  color: #fff !important;
}

.qtd_card {
  font-size: 28px;
  font-weight: 600;
}
</style>
